module.exports = __webpack_public_path__ + "static/media/Ojo.994796bc.png";